import { render, staticRenderFns } from "./EducationPaymentPreview.vue?vue&type=template&id=2fd52048"
import script from "./EducationPaymentPreview.vue?vue&type=script&lang=ts"
export * from "./EducationPaymentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports